export enum SsoRequestTypes {
  GetPreSsoConnectionInfoRequest = 'sso.getPreSsoConnectionInfo.request',
  GetPreSsoConnectionInfoSuccess = 'sso.getPreSsoConnectionInfo.success',
  GetPreSsoConnectionInfoFailure = 'sso.getPreSsoConnectionInfo.failure',
  GetSsoSettingsRequest = 'sso.getSsoSettings.request',
  GetSsoSettingsSuccess = 'sso.getSsoSettings.success',
  GetSsoSettingsFailure = 'sso.getSsoSettings.failure',
  ProvisionSsoRequest = 'sso.provisionSso.request',
  ProvisionSsoSuccess = 'sso.provisionSso.success',
  ProvisionSsoFailure = 'sso.provisionSso.failure',
  SetSsoAuthEnforcedRequest = 'sso.setSsoAuthEnforced.request',
  SetSsoAuthEnforcedSuccess = 'sso.setSsoAuthEnforced.success',
  SetSsoAuthEnforcedFailure = 'sso.setSsoAuthEnforced.failure',
  AddTeamDomainRequest = 'sso.addTeamDomain.request',
  AddTeamDomainSuccess = 'sso.addTeamDomain.success',
  AddTeamDomainFailure = 'sso.addTeamDomain.failure',
  RemoveTeamDomainRequest = 'sso.removeTeamDomain.request',
  RemoveTeamDomainSuccess = 'sso.removeTeamDomain.success',
  RemoveTeamDomainFailure = 'sso.removeTeamDomain.failure',
  UpdateSsoConfigRequest = 'sso.updateSsoConfig.request',
  UpdateSsoConfigSuccess = 'sso.updateSsoConfig.success',
  UpdateSsoConfigFailure = 'sso.updateSsoConfig.failure',
  DeprovisionSsoRequest = 'sso.deprovisionSso.request',
  DeprovisionSsoSuccess = 'sso.deprovisionSso.success',
  DeprovisionSsoFailure = 'sso.deprovisionSso.failure',
}
